import React__default from 'react';
import 'classnames';
import OutlineMessageDanger from '../icons/generated/outline/OutlineMessageDanger.js';
import OutlineMessageInfo from '../icons/generated/outline/OutlineMessageInfo.js';
import OutlineMessageSuccess from '../icons/generated/outline/OutlineMessageSuccess.js';
import OutlineMessageWarning from '../icons/generated/outline/OutlineMessageWarning.js';
var useToast = function useToast() {
  var icons = {
    success: function success() {
      return /* @__PURE__ */React__default.createElement(OutlineMessageSuccess, null);
    },
    info: function info() {
      return /* @__PURE__ */React__default.createElement(OutlineMessageInfo, null);
    },
    error: function error() {
      return /* @__PURE__ */React__default.createElement(OutlineMessageDanger, null);
    },
    warning: function warning() {
      return /* @__PURE__ */React__default.createElement(OutlineMessageWarning, null);
    }
  };
  return {
    icons: icons
  };
};
export { useToast as default };